export interface GamePlatform { id: string; name: string; family: string }
export interface GameReference { id: string; title: string; year: number; platforms: string[]; genre: string; mapUrl?: string; officialUrl?: string; announced?: boolean; seasonal?: boolean; procedural?: boolean }
export const GAME_CATALOG_REVIEWED = "2026-09-12";
export const GAME_PLATFORMS: GamePlatform[] = [
  {
    "id": "ps1",
    "name": "PlayStation",
    "family": "PlayStation"
  },
  {
    "id": "ps2",
    "name": "PlayStation 2",
    "family": "PlayStation"
  },
  {
    "id": "ps3",
    "name": "PlayStation 3",
    "family": "PlayStation"
  },
  {
    "id": "ps4",
    "name": "PlayStation 4",
    "family": "PlayStation"
  },
  {
    "id": "ps5",
    "name": "PlayStation 5",
    "family": "PlayStation"
  },
  {
    "id": "psp",
    "name": "PSP",
    "family": "PlayStation"
  },
  {
    "id": "psvita",
    "name": "PS Vita",
    "family": "PlayStation"
  },
  {
    "id": "xbox",
    "name": "Xbox original",
    "family": "Xbox"
  },
  {
    "id": "xbox360",
    "name": "Xbox 360",
    "family": "Xbox"
  },
  {
    "id": "xboxone",
    "name": "Xbox One",
    "family": "Xbox"
  },
  {
    "id": "xboxseries",
    "name": "Xbox Series X|S",
    "family": "Xbox"
  },
  {
    "id": "nes",
    "name": "NES",
    "family": "Nintendo"
  },
  {
    "id": "snes",
    "name": "Super Nintendo",
    "family": "Nintendo"
  },
  {
    "id": "n64",
    "name": "Nintendo 64",
    "family": "Nintendo"
  },
  {
    "id": "gamecube",
    "name": "GameCube",
    "family": "Nintendo"
  },
  {
    "id": "wii",
    "name": "Wii",
    "family": "Nintendo"
  },
  {
    "id": "wiiu",
    "name": "Wii U",
    "family": "Nintendo"
  },
  {
    "id": "gb",
    "name": "Game Boy",
    "family": "Nintendo"
  },
  {
    "id": "gbc",
    "name": "Game Boy Color",
    "family": "Nintendo"
  },
  {
    "id": "gba",
    "name": "Game Boy Advance",
    "family": "Nintendo"
  },
  {
    "id": "ds",
    "name": "Nintendo DS",
    "family": "Nintendo"
  },
  {
    "id": "3ds",
    "name": "Nintendo 3DS",
    "family": "Nintendo"
  },
  {
    "id": "switch",
    "name": "Nintendo Switch",
    "family": "Nintendo"
  },
  {
    "id": "switch2",
    "name": "Nintendo Switch 2",
    "family": "Nintendo"
  }
];
export const GAME_REFERENCES: GameReference[] = [
  {
    "id": "ff7",
    "title": "Final Fantasy VII",
    "year": 1997,
    "platforms": [
      "ps1"
    ],
    "genre": "Rol"
  },
  {
    "id": "mgs",
    "title": "Metal Gear Solid",
    "year": 1998,
    "platforms": [
      "ps1"
    ],
    "genre": "Acción"
  },
  {
    "id": "crash",
    "title": "Crash Bandicoot",
    "year": 1996,
    "platforms": [
      "ps1"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "spyro",
    "title": "Spyro the Dragon",
    "year": 1998,
    "platforms": [
      "ps1"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "tekken3",
    "title": "Tekken 3",
    "year": 1997,
    "platforms": [
      "ps1"
    ],
    "genre": "Lucha"
  },
  {
    "id": "gt2",
    "title": "Gran Turismo 2",
    "year": 1999,
    "platforms": [
      "ps1"
    ],
    "genre": "Carreras"
  },
  {
    "id": "sotn",
    "title": "Castlevania: Symphony of the Night",
    "year": 1997,
    "platforms": [
      "ps1"
    ],
    "genre": "Aventura"
  },
  {
    "id": "tombraider",
    "title": "Tomb Raider",
    "year": 1996,
    "platforms": [
      "ps1"
    ],
    "genre": "Aventura"
  },
  {
    "id": "gow2",
    "title": "God of War II",
    "year": 2007,
    "platforms": [
      "ps2"
    ],
    "genre": "Acción"
  },
  {
    "id": "sotc",
    "title": "Shadow of the Colossus",
    "year": 2005,
    "platforms": [
      "ps2"
    ],
    "genre": "Aventura"
  },
  {
    "id": "ff10",
    "title": "Final Fantasy X",
    "year": 2001,
    "platforms": [
      "ps2"
    ],
    "genre": "Rol"
  },
  {
    "id": "gta-sa",
    "title": "GTA: San Andreas",
    "year": 2004,
    "platforms": [
      "ps2",
      "xbox"
    ],
    "genre": "Acción"
  },
  {
    "id": "jak",
    "title": "Jak and Daxter: The Precursor Legacy",
    "year": 2001,
    "platforms": [
      "ps2"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "mgs3",
    "title": "Metal Gear Solid 3: Snake Eater",
    "year": 2004,
    "platforms": [
      "ps2"
    ],
    "genre": "Acción"
  },
  {
    "id": "gow-psp",
    "title": "God of War: Chains of Olympus",
    "year": 2008,
    "platforms": [
      "psp"
    ],
    "genre": "Acción"
  },
  {
    "id": "gravity-rush",
    "title": "Gravity Rush",
    "year": 2012,
    "platforms": [
      "psvita"
    ],
    "genre": "Aventura"
  },
  {
    "id": "uncharted2",
    "title": "Uncharted 2: Among Thieves",
    "year": 2009,
    "platforms": [
      "ps3"
    ],
    "genre": "Aventura"
  },
  {
    "id": "tlou",
    "title": "The Last of Us",
    "year": 2013,
    "platforms": [
      "ps3"
    ],
    "genre": "Aventura"
  },
  {
    "id": "halo-ce",
    "title": "Halo: Combat Evolved",
    "year": 2001,
    "platforms": [
      "xbox"
    ],
    "genre": "Acción"
  },
  {
    "id": "halo2",
    "title": "Halo 2",
    "year": 2004,
    "platforms": [
      "xbox"
    ],
    "genre": "Acción"
  },
  {
    "id": "fable",
    "title": "Fable",
    "year": 2004,
    "platforms": [
      "xbox"
    ],
    "genre": "Rol"
  },
  {
    "id": "kotor",
    "title": "Star Wars: Knights of the Old Republic",
    "year": 2003,
    "platforms": [
      "xbox"
    ],
    "genre": "Rol"
  },
  {
    "id": "jade",
    "title": "Jade Empire",
    "year": 2005,
    "platforms": [
      "xbox"
    ],
    "genre": "Rol"
  },
  {
    "id": "halo3",
    "title": "Halo 3",
    "year": 2007,
    "platforms": [
      "xbox360"
    ],
    "genre": "Acción"
  },
  {
    "id": "gears2",
    "title": "Gears of War 2",
    "year": 2008,
    "platforms": [
      "xbox360"
    ],
    "genre": "Acción"
  },
  {
    "id": "fable2",
    "title": "Fable II",
    "year": 2008,
    "platforms": [
      "xbox360"
    ],
    "genre": "Rol"
  },
  {
    "id": "lost-odyssey",
    "title": "Lost Odyssey",
    "year": 2007,
    "platforms": [
      "xbox360"
    ],
    "genre": "Rol"
  },
  {
    "id": "mass-effect",
    "title": "Mass Effect",
    "year": 2007,
    "platforms": [
      "xbox360"
    ],
    "genre": "Rol"
  },
  {
    "id": "rdr",
    "title": "Red Dead Redemption",
    "year": 2010,
    "platforms": [
      "ps3",
      "xbox360"
    ],
    "genre": "Aventura"
  },
  {
    "id": "bioshock",
    "title": "BioShock",
    "year": 2007,
    "platforms": [
      "xbox360",
      "ps3"
    ],
    "genre": "Acción"
  },
  {
    "id": "smb3",
    "title": "Super Mario Bros. 3",
    "year": 1988,
    "platforms": [
      "nes"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "zelda1",
    "title": "The Legend of Zelda",
    "year": 1986,
    "platforms": [
      "nes"
    ],
    "genre": "Aventura"
  },
  {
    "id": "mario-world",
    "title": "Super Mario World",
    "year": 1990,
    "platforms": [
      "snes"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "zelda-alttp",
    "title": "The Legend of Zelda: A Link to the Past",
    "year": 1991,
    "platforms": [
      "snes"
    ],
    "genre": "Aventura"
  },
  {
    "id": "super-metroid",
    "title": "Super Metroid",
    "year": 1994,
    "platforms": [
      "snes"
    ],
    "genre": "Aventura"
  },
  {
    "id": "dk-country",
    "title": "Donkey Kong Country",
    "year": 1994,
    "platforms": [
      "snes"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "mario64",
    "title": "Super Mario 64",
    "year": 1996,
    "platforms": [
      "n64"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "zelda-oot",
    "title": "The Legend of Zelda: Ocarina of Time",
    "year": 1998,
    "platforms": [
      "n64"
    ],
    "genre": "Aventura"
  },
  {
    "id": "zelda-mm",
    "title": "The Legend of Zelda: Majora's Mask",
    "year": 2000,
    "platforms": [
      "n64"
    ],
    "genre": "Aventura"
  },
  {
    "id": "banjo",
    "title": "Banjo-Kazooie",
    "year": 1998,
    "platforms": [
      "n64"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "metroid-prime",
    "title": "Metroid Prime",
    "year": 2002,
    "platforms": [
      "gamecube"
    ],
    "genre": "Aventura"
  },
  {
    "id": "zelda-ww",
    "title": "The Legend of Zelda: The Wind Waker",
    "year": 2002,
    "platforms": [
      "gamecube"
    ],
    "genre": "Aventura"
  },
  {
    "id": "mario-galaxy",
    "title": "Super Mario Galaxy",
    "year": 2007,
    "platforms": [
      "wii"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "pokemon-red",
    "title": "Pokémon Rojo / Azul",
    "year": 1996,
    "platforms": [
      "gb"
    ],
    "genre": "Rol"
  },
  {
    "id": "pokemon-crystal",
    "title": "Pokémon Cristal",
    "year": 2000,
    "platforms": [
      "gbc"
    ],
    "genre": "Rol"
  },
  {
    "id": "pokemon-emerald",
    "title": "Pokémon Esmeralda",
    "year": 2004,
    "platforms": [
      "gba"
    ],
    "genre": "Rol"
  },
  {
    "id": "pokemon-hgss",
    "title": "Pokémon HeartGold / SoulSilver",
    "year": 2009,
    "platforms": [
      "ds"
    ],
    "genre": "Rol"
  },
  {
    "id": "zelda-albw",
    "title": "The Legend of Zelda: A Link Between Worlds",
    "year": 2013,
    "platforms": [
      "3ds"
    ],
    "genre": "Aventura"
  },
  {
    "id": "xeno-x",
    "title": "Xenoblade Chronicles X",
    "year": 2015,
    "platforms": [
      "wiiu"
    ],
    "genre": "Rol"
  },
  {
    "id": "ac-odyssey",
    "title": "Assassin's Creed Odyssey",
    "year": 2018,
    "platforms": [
      "ps4",
      "xboxone"
    ],
    "genre": "Aventura",
    "mapUrl": "https://mapgenie.io/assassins-creed-odyssey"
  },
  {
    "id": "gta5",
    "title": "GTA V",
    "year": 2013,
    "platforms": [
      "ps3",
      "xbox360",
      "ps4",
      "xboxone",
      "ps5",
      "xboxseries"
    ],
    "genre": "Acción"
  },
  {
    "id": "rdr2",
    "title": "Red Dead Redemption 2",
    "year": 2018,
    "platforms": [
      "ps4",
      "xboxone"
    ],
    "genre": "Aventura",
    "mapUrl": "https://rdr2map.com/"
  },
  {
    "id": "skyrim",
    "title": "The Elder Scrolls V: Skyrim",
    "year": 2011,
    "platforms": [
      "ps3",
      "xbox360",
      "ps4",
      "xboxone",
      "ps5",
      "xboxseries",
      "switch"
    ],
    "genre": "Rol"
  },
  {
    "id": "witcher3",
    "title": "The Witcher 3: Wild Hunt",
    "year": 2015,
    "platforms": [
      "ps4",
      "xboxone",
      "ps5",
      "xboxseries",
      "switch"
    ],
    "genre": "Rol"
  },
  {
    "id": "zelda-botw",
    "title": "The Legend of Zelda: Breath of the Wild",
    "year": 2017,
    "platforms": [
      "wiiu",
      "switch",
      "switch2"
    ],
    "genre": "Aventura"
  },
  {
    "id": "mario-odyssey",
    "title": "Super Mario Odyssey",
    "year": 2017,
    "platforms": [
      "switch"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "acnh",
    "title": "Animal Crossing: New Horizons",
    "year": 2020,
    "platforms": [
      "switch"
    ],
    "genre": "Simulación"
  },
  {
    "id": "smash",
    "title": "Super Smash Bros. Ultimate",
    "year": 2018,
    "platforms": [
      "switch"
    ],
    "genre": "Lucha"
  },
  {
    "id": "halo-infinite",
    "title": "Halo Infinite",
    "year": 2021,
    "platforms": [
      "xboxone",
      "xboxseries"
    ],
    "genre": "Acción"
  },
  {
    "id": "forza5",
    "title": "Forza Horizon 5",
    "year": 2021,
    "platforms": [
      "xboxone",
      "xboxseries",
      "ps5"
    ],
    "genre": "Carreras"
  },
  {
    "id": "sea-thieves",
    "title": "Sea of Thieves",
    "year": 2018,
    "platforms": [
      "xboxone",
      "xboxseries",
      "ps5"
    ],
    "genre": "Aventura"
  },
  {
    "id": "ori2",
    "title": "Ori and the Will of the Wisps",
    "year": 2020,
    "platforms": [
      "xboxone",
      "xboxseries",
      "switch"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "elden-ring",
    "title": "Elden Ring",
    "year": 2022,
    "platforms": [
      "ps4",
      "ps5",
      "xboxone",
      "xboxseries"
    ],
    "genre": "Rol",
    "mapUrl": "https://mapgenie.io/elden-ring"
  },
  {
    "id": "horizon-fw",
    "title": "Horizon Forbidden West",
    "year": 2022,
    "platforms": [
      "ps4",
      "ps5"
    ],
    "genre": "Aventura"
  },
  {
    "id": "gow-ragnarok",
    "title": "God of War Ragnarök",
    "year": 2022,
    "platforms": [
      "ps4",
      "ps5"
    ],
    "genre": "Acción"
  },
  {
    "id": "tsushima",
    "title": "Ghost of Tsushima",
    "year": 2020,
    "platforms": [
      "ps4",
      "ps5"
    ],
    "genre": "Aventura"
  },
  {
    "id": "astro",
    "title": "Astro Bot",
    "year": 2024,
    "platforms": [
      "ps5"
    ],
    "genre": "Plataformas",
    "officialUrl": "https://www.playstation.com/en-us/games/astro-bot/"
  },
  {
    "id": "yotei",
    "title": "Ghost of Yōtei",
    "year": 2025,
    "platforms": [
      "ps5"
    ],
    "genre": "Aventura",
    "officialUrl": "https://www.playstation.com/en-us/games/ghost-of-yotei/"
  },
  {
    "id": "ff7-rebirth",
    "title": "Final Fantasy VII Rebirth",
    "year": 2024,
    "platforms": [
      "ps5"
    ],
    "genre": "Rol"
  },
  {
    "id": "spider2",
    "title": "Marvel's Spider-Man 2",
    "year": 2023,
    "platforms": [
      "ps5"
    ],
    "genre": "Aventura"
  },
  {
    "id": "ds2",
    "title": "Death Stranding 2: On the Beach",
    "year": 2025,
    "platforms": [
      "ps5"
    ],
    "genre": "Aventura"
  },
  {
    "id": "avowed",
    "title": "Avowed",
    "year": 2025,
    "platforms": [
      "xboxseries"
    ],
    "genre": "Rol",
    "officialUrl": "https://www.xbox.com/en-US/games/avowed"
  },
  {
    "id": "indiana",
    "title": "Indiana Jones and the Great Circle",
    "year": 2024,
    "platforms": [
      "xboxseries",
      "ps5"
    ],
    "genre": "Aventura"
  },
  {
    "id": "starfield",
    "title": "Starfield",
    "year": 2023,
    "platforms": [
      "xboxseries"
    ],
    "genre": "Rol"
  },
  {
    "id": "zelda-totk",
    "title": "The Legend of Zelda: Tears of the Kingdom",
    "year": 2023,
    "platforms": [
      "switch",
      "switch2"
    ],
    "genre": "Aventura",
    "mapUrl": "https://mapgenie.io/zelda-tears-of-the-kingdom"
  },
  {
    "id": "mario-wonder",
    "title": "Super Mario Bros. Wonder",
    "year": 2023,
    "platforms": [
      "switch"
    ],
    "genre": "Plataformas"
  },
  {
    "id": "mario-kart-world",
    "title": "Mario Kart World",
    "year": 2025,
    "platforms": [
      "switch2"
    ],
    "genre": "Carreras",
    "officialUrl": "https://www.nintendo.com/us/store/products/mario-kart-world-switch-2/"
  },
  {
    "id": "dk-bananza",
    "title": "Donkey Kong Bananza",
    "year": 2025,
    "platforms": [
      "switch2"
    ],
    "genre": "Plataformas",
    "officialUrl": "https://www.nintendo.com/us/store/products/donkey-kong-bananza-switch-2/"
  },
  {
    "id": "zelda-echoes",
    "title": "The Legend of Zelda: Echoes of Wisdom",
    "year": 2024,
    "platforms": [
      "switch"
    ],
    "genre": "Aventura"
  },
  {
    "id": "hogwarts",
    "title": "Hogwarts Legacy",
    "year": 2023,
    "platforms": [
      "ps4",
      "ps5",
      "xboxone",
      "xboxseries",
      "switch",
      "switch2"
    ],
    "genre": "Aventura",
    "mapUrl": "https://mapgenie.io/hogwarts-legacy"
  },
  {
    "id": "baldurs3",
    "title": "Baldur's Gate 3",
    "year": 2023,
    "platforms": [
      "ps5",
      "xboxseries"
    ],
    "genre": "Rol"
  },
  {
    "id": "expedition33",
    "title": "Clair Obscur: Expedition 33",
    "year": 2025,
    "platforms": [
      "ps5",
      "xboxseries"
    ],
    "genre": "Rol"
  },
  {
    "id": "fortnite",
    "title": "Fortnite",
    "year": 2017,
    "platforms": [
      "ps4",
      "ps5",
      "xboxone",
      "xboxseries",
      "switch",
      "switch2"
    ],
    "genre": "Acción",
    "mapUrl": "https://fortnite.gg/",
    "seasonal": true
  },
  {
    "id": "minecraft",
    "title": "Minecraft",
    "year": 2011,
    "platforms": [
      "ps4",
      "ps5",
      "xboxone",
      "xboxseries",
      "switch"
    ],
    "genre": "Construcción",
    "procedural": true
  },
  {
    "id": "gta6",
    "title": "GTA VI",
    "year": 2026,
    "platforms": [
      "ps5",
      "xboxseries"
    ],
    "genre": "Acción",
    "officialUrl": "https://www.rockstargames.com/VI",
    "announced": true
  }
];
// Platform lists identify reference editions, not an exhaustive compatibility or storefront inventory.
// Remakes, emulated releases, DLC and patches must be specified in the user's game context.
export const normalizeGameText = (text: string) => text.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
export function filterGames(games: GameReference[], query: string, family: string, platform: string, era: string): GameReference[] {
  return games.filter(game =>
    normalizeGameText(game.title + " " + game.genre).includes(normalizeGameText(query)) &&
    (family === "Todas" || game.platforms.some(id => GAME_PLATFORMS.some(p => p.id === id && p.family === family))) &&
    (platform === "Todas" || game.platforms.includes(platform)) &&
    (era === "Todas" || era === "Clásicos" && game.year <= 2010 || era === "Modernos" && game.year > 2010 && game.year < 2023 || era === "Recientes" && game.year >= 2023 && !game.announced || era === "Anunciados" && game.announced === true)
  );
}
